import { Location, TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Subscription, Subject } from 'rxjs';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';
import { OpenaiService } from 'src/app/openai/openai.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import cjson from 'compressed-json';



@Component({
    selector: 'app-skills-tab',
    templateUrl: './skills-tab.component.html',
    styleUrls: ['./skills-tab.component.scss'],
    standalone: false
})
export class SkillsTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService, private talentInsightsService: TalentInsightsService, private openaiService: OpenaiService) { }
  companyDetails: any;
  currentCompanyName: any;
  skills: any;
  skillsData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'graph', 'job_doc_count'];
 // @ViewChild('skillsTbSort') skillsTbSort: MatSort;
  @ViewChild(MatSort) sort: MatSort;

  totalResultCount: number = 0;
  startindex: number = 0;
  aggregatescount: number = 50;
  topFiveSkills: any = [];
  alternatecompanyNames: any[] = []

  /** start index in page */
  start: number = 0;
  /**End index in page */
  end: number = 10;
  /**Number of items on each of page */
  pageSize:number = 10;
  /**Current page number */
  currentPage: number = 1;
  /**Total items */
  totalCount = 0;

  skillsubscription: Subscription;
  skillemptystate: Boolean = false;
  skilldataforsort: any;
  initialSortColumns: string[] = ['doc_count', 'graph'];
  skillsdataAI: any = {}
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};

  insightsExportSubscription: Subscription = null;

  /**
* Mapping of key and text value of headers
* In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
*/
  tableHeaderObj = {
    "TopSkills": "Top Skills in",
    "TalentCount": "Talent Count",
    "%OfTotal": "% of Total",
    "JobDemand": "Job Posts"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  combinedAggregates: any;
  combinedIndustry: any
  combinedSkills: any;
  combinedJobtitle: any;
  combinedLocation: any;
  hasJobDemand: boolean = false;
  filterData: any;
  aiSuggestions: any;

  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  sliderPayload:any
  hasJobListingAccess:any

  ngOnInit(): void {
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.setCompanyDetails();
    this.getJobtitleSkillSuggestions();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
       const extra = _methodDetails;
       this.filterData = this.filterDataHandlerService.fetchFilterData;
        if (extra?.filterType == 'skills' || extra?.filterType == 'jobtitle' || extra?.filterType == 'keyword' || extra?.filterType == 'pastjobtitle' || extra?.filterType == 'search' || extra?.filterType == 'allfilters') {
        this.getJobtitleSkillSuggestions();
      } else if (extra?.filterType == 'location' || extra?.filterType == 'industry' || extra?.filterType == 'company' || extra?.filterType == 'seniority' || extra?.filterType == 'function' || extra?.filterType == 'functions' || extra?.filterType == 'locationRange') {
        this.fetchPageData();
      } else {
        this.fetchPageData();
      }
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    this.hasJobListingAccess = this.localStorageService.getItem('hasjoblistingaccess')
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getSkills();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getSkills() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "skills";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.companyids = [this.companyDetails.id];
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.skills;
      this.totalCount = tempData.length;
      this.skilldataforsort = tempData
      this.skillsData = tempData.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      this.skills.sort = this.sort;
      this.manualSort();
      this.getskillsdataai(this.skilldataforsort);
      this.getJobsAggregates();

      this.topFiveSkills = tempData.slice(0, 5);
      this.skillemptystate = true;
    });
  }



  getSkillPercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  /**
   * Function set the start and end of aggreggate datat according to page number
   * @param index page number in pagination
   */
  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
      this.manualSort();
  }

  /**
   * Sort the array
   *
   */
  manualSort() {
    this.reSortArray(this.sort);
  }

  /**
   * Re-sort the array
   * @param {MatSort} sort
   */
  private reSortArray(sort: MatSort) {
    const data = this.skilldataforsort;
    if (!sort|| !sort.active || sort.direction === '') {
      this.skillsData = data.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      return;
    }

    this.skilldataforsort = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        default: return 0;
      }
    });
    this.skillsData = this.skilldataforsort.slice(this.start, this.end);
    this.skills = new MatTableDataSource(this.skillsData);
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'skills') return;

    this.tableHeaderName = [`${this.tableHeaderObj['TopSkills']} ${GlobalService.titleCase(this.companyDetails.name)}`, this.tableHeaderObj['TalentCount'], this.tableHeaderObj['%OfTotal'], this.tableHeaderObj['JobDemand']];
    const skillDataForExport = this.skilldataforsort.map(skill => {
      return {
        ...skill,
        job_doc_count: skill.job_doc_count || '—',
      };
    });
    const payloadForInsightsExport: ExportPayload = {
      tab: 'skills',
      companydetails: this.companyDetails,
      totalresultcount: this.totalResultCount,
      skills: skillDataForExport,
      tableHeader: this.tableHeaderName
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
     const redirectFilters: Partial<FilterParams> = {
                // Company context — always present
                companyid: this.companyDetails?.id,
                companyname: this.currentCompanyName,
                alternativecompanynames: this.alternatecompanyNames,

                // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
                // sidebar). Nested so it can never collide with the listing page's normal filters.
                insightsFilterData: this.filterData,
              };
    switch(type) {
      case 'skills': redirectFilters['mandatoryskills'] = [key]; break;
    }

   const uniqueKey = this.hashService.generateUniqueHash();
      localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

      const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
      window.open(url, '_blank');
  }

  getskillsdataai(data) {
    let skillsdata: any;
    skillsdata = data.map(x=>{
      let res: any ={};
      res['Top Skills'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getSkillPercentage(x.doc_count) + '%';
      res['Job Posts'] = x.job_doc_count || 0;
      return res;

    })
    this.skillsdataAI = {
      skills: skillsdata
    }
    if(skillsdata.length == 0)
      this.skillsdataAI = null;

  }

  getCombinedAggregates() {
       this.hasJobDemand = true;
      this.skilldataforsort = this.skilldataforsort.map(skills => {
      skills.job_doc_count = '';
      return skills;
    });

      const request = this.aggService.getRequestWithFilters();
      request.aggregatetype = "jobs_base_aggregates";
      request.aggregatescount = 50;
      request.companyids = [this.companyDetails.id];
        this.personSearchService.getTotalAggs(request).subscribe(response => {
     //   this.locationAPiCalled = true;
        const tempData = response?.data?.aggregations;
        this.combinedAggregates = tempData;
         this.combinedIndustry = this.combinedAggregates['current_industry'];
        this.combinedSkills = this.combinedAggregates['skills'];
        this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
        this.combinedLocation = this.combinedAggregates['location'];
        this.getJobsAggregates();
      });
    }

    getJobsAggregates() {
      this.hasJobDemand = true;
    this.aiSuggestions = this.localStorageService.getItem('companyaiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'skills-job_demand',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      companyids: [this.companyDetails.id],
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],

    }
          this.sliderPayload = payload

          this.talentInsightsService.getJobsAggregates(payload).subscribe((response:any) => {
            const tempData = response?.data?.aggregations['skills-job_demand'];
             this.hasJobDemand = false;
            this.skilldataforsort.map(skills => {
              const medianSalaryData = tempData.find(item => item.key.toLowerCase().trim() === skills.key.toLowerCase().trim());
              if(medianSalaryData) {
                skills.job_doc_count = medianSalaryData?.job_demand?.doc_count || '';
              } else {
                skills.job_doc_count = '';
              }
              return skills;
            });
            this.getskillsdataai(this.skilldataforsort);
          })
        }

  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus(){
    return this.hasJobDemand;
  }
   openJoblistSlider(value:any){
     Object.assign(this.sliderPayload, {mandatory_skills:[value]})
      this.sendDataToSliderSubject.next(this.sliderPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
    }

    getJobtitleSkillSuggestions() {
    const aggReq = this.aggService.getRequestWithFilters();
    if ((aggReq?.preferredskills?.length > 0 || aggReq?.jobtitles?.length > 0) || (aggReq?.booleanquery != '*') || aggReq?.pastjobtitles?.length > 0) {
      const payload = {
        skills: aggReq.preferredskills,
        jobtitles: aggReq?.jobtitles,
        boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
      }

      this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe(async (res: any) => {
        const responseData = res.data;
        const titles = [...(responseData.suggestedjobtitles || [])];
        const skills = [...(responseData.suggestedskills || [])];
        const filterSuggestions = {
          jobtitles: titles,
          skills: skills
        }
        this.localStorageService.setItem('companyaiSuggestions', filterSuggestions);
        this.fetchPageData();


      })
    } else {
      this.localStorageService.setItem('companyaiSuggestions', null);
      this.fetchPageData();
    }
  }
}
